<template>
    <el-dialog
    :visible.sync="iframeSrcDialog"
    :close-on-click-modal="false"
    width="80%"
    :show-close="false"
    top="52px"
    :append-to-body="true"
  >
      <p class="arrow">
        <!-- <el-button icon="el-icon-download" @click="download()" style="download" type="primary" size="mini">下载</el-button> -->
      <span style="float :right;padding-right:40px;font-size: 14px;color: #FFFFFF;cursor: pointer;" @click="close">关闭</span></p>
      <iframe :src="iframeSrc" style="height:100%;width:100%;border:0;" align="middle"></iframe>
  </el-dialog>
</template>

<script>
import { Message } from "element-ui";
import req from "@/request.js";
export default {
    props:["iframeSrc","fileRow"],
    data () {
      return {
        iframeSrcDialog:false
      }
    },
    methods: {
      handleOpen() {
        this.iframeSrcDialog = true;
      },
      //关闭弹框
      close(){
        this.iframeSrcDialog = false;
      },
      //附件下载
      download(){
        console.log(this.iframeSrc);
        let idocvUrl = "http://10.10.10.74:8168";
        //***** 外网 *****/
        if(window.location.origin.indexOf("http://61.144.170.91")>-1){//副线环境
          idocvUrl = "http://61.144.170.91:8168";
        }

        if(window.location.origin.indexOf("http://zs.haiya.com.cn")>-1){//副线环境
          idocvUrl = "http://61.144.170.91:8168";
        }

        var reg = new RegExp(idocvUrl+"/view/","g");//清除指定url，截取uuid
        window.open(idocvUrl+"/doc/download/"+this.iframeSrc.replace(reg,""));
      }
    }
  }
</script>

<style lang="scss" scoped>
@import "@/assets/css/element-variables.scss";

/deep/ .el-icon-close{
  width: 30px;
  height: 30px;
}
.currentPage {
  cursor: pointer;
  color: #8c8e92;
}

.currentPage:hover {
  color: $--theme-color;
}
.arrow{
  position: fixed;
  top: 0px;
  z-index: 2;
  width: 100%;
  background-color: #191919;
  padding: 12px 0;
  margin: 0;
  text-align :center;
}
/deep/.el-dialog__body{
  height: calc(100% - 52px);
  color: $--color-text-regular;
  font-size: 14px;
  padding:0;
  padding-left:30px;
}
/deep/.el-dialog {
   height: calc(100% - 52px);
    position: relative;
    margin: 0 auto 0;
    background: #fff;
    border-radius: 2px;
    -webkit-box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.3);
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 50%;
}
</style>